export default "__VITE_ASSET__GZGbaq83__"